export default __webpack_public_path__ + "static/media/enghien27.ff948d99.jpg";